export default "__VITE_ASSET__DOJeubcE__"